/* src/app/views/product-create-search/new-price/new-price.component.scss */
.container {
  width: 100%;
  max-width: none;
  margin: 0 0 24px;
  background: #ffffff;
  -webkit-box-shadow: 0px 3px 5px 0px rgb(184, 175, 184);
  -moz-box-shadow: 0px 3px 5px 0px rgb(184, 175, 184);
  box-shadow: 1.5px 3px 5px 1.5px rgb(184, 175, 184);
  border-radius: 6px;
  box-sizing: border-box;
  overflow: visible;
}
.container-header {
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 20px;
}
.title {
  font-weight: normal;
  font-style: normal;
  font-size: clamp(28px, 2.2vw, 48px);
  line-height: 1.2;
  color: #333333;
  margin: 10px 0 0 48px;
}
.loading {
  position: absolute;
  top: 35%;
  left: 50%;
  font-size: 60px;
  font-weight: bold;
}
form {
  border-radius: unset;
  padding: unset;
  box-shadow: unset;
}
.container-body {
  margin-top: 16px;
  margin-bottom: 0;
  width: 100%;
  border: none;
}
.new-product-itens {
  width: 100%;
  max-width: 1240px;
  margin: 0 auto;
  padding: 8px 36px 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.element-text-select,
.element-text-longe {
  display: flex;
  flex-wrap: wrap;
  width: calc(100% + 24px);
  margin: 0 -12px;
}
.element-text-select > [class*=col-],
.element-text-longe > [class*=col-] {
  padding: 0 12px 16px;
}
.element-text-select > .element-option-select,
.element-text-select > .element-add-edit {
  flex: 0 0 33.3333% !important;
  max-width: 33.3333% !important;
}
.element-text-longe > .textarea-row {
  flex: 0 0 100% !important;
  max-width: 100% !important;
}
.element-option-select,
.element-text-center,
.element-add-edit {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: initial;
  color: #333333;
  font-family: Ford F-1;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
}
.element-option-select-filter,
.element-text-center-label,
.element-add-edit-label {
  margin-bottom: 5px;
}
.space-left {
  margin-left: 0;
}
.element-add-edit-input,
.element-text-center-input {
  width: 100%;
  max-width: 100%;
  margin-top: 0;
}
.element-option-select .p-dropdown,
.element-option-select .ui-dropdown,
.element-option-select .p-inputtext,
.element-option-select .ui-inputtext,
.element-add-edit .p-inputtext,
.element-add-edit .ui-inputtext {
  width: 100% !important;
  min-height: 40px;
}
.element-add-edit-input {
  height: 40px;
}
.element-text-center-input {
  min-height: 96px;
  height: 96px;
}
.char-counter {
  font-size: 12px;
  color: #999999;
  margin-top: 5px;
}
.actions-section {
  width: 100%;
}
.button-position {
  width: 100%;
  max-width: 1240px;
  margin: 0 auto;
  padding: 22px 36px 32px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
}
.btn-save,
.btn-return {
  width: 137px;
  height: 48px;
  border-radius: 10px;
  margin: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.btn-save {
  background: #046cea;
  border: 1px solid #046cea;
}
.btn-save-label {
  font-size: 15pt;
  font-weight: 500;
  color: #ffffff;
}
.btn-save:hover {
  background: #044ea7;
}
.btn-return {
  background: #ffffff;
  border: 1px solid #046cea;
}
.btn-return-label {
  font-size: 15pt;
  font-weight: 500;
  color: #046cea;
  margin-left: 5px;
}
.btn-return:hover {
  background: #044ea7;
}
button.btn-return:hover .btn-return-label {
  color: #ffffff;
}
@media only screen and (max-width: 1200px) {
  .title {
    margin-left: 28px;
  }
  .new-product-itens,
  .button-position {
    padding-left: 24px;
    padding-right: 24px;
  }
}
@media only screen and (max-width: 768px) {
  .container-header {
    margin-top: 12px;
  }
  .title {
    margin-left: 16px;
    margin-top: 4px;
    font-size: clamp(24px, 6vw, 32px);
  }
  .new-product-itens,
  .button-position {
    padding-left: 16px;
    padding-right: 16px;
  }
  .button-position {
    padding-top: 18px;
    padding-bottom: 24px;
  }
  .element-option-select,
  .element-text-center,
  .element-add-edit {
    font-size: 14px;
    line-height: 20px;
  }
  .element-text-select > .element-option-select,
  .element-text-select > .element-add-edit,
  .element-text-longe > .textarea-row {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
}
@media only screen and (max-width: 576px) {
  .btn-save,
  .btn-return {
    width: 100%;
  }
  .button-position {
    gap: 10px;
  }
  .element-add-edit-input {
    height: 38px;
  }
}
@media only screen and (min-width: 1920px) {
  .new-product-itens,
  .button-position {
    max-width: 1240px;
  }
  .element-add-edit-input {
    height: 44px;
  }
}
.element-add-edit-label,
.element-add-edit-filter,
.element-option-select-filter,
.element-text-center-label,
.selected-edit-title {
  font-size: 1.0625rem;
  line-height: 1.35;
  font-weight: 500;
}
.char-counter {
  font-size: 0.875rem;
  line-height: 1.35;
}
::ng-deep .container .p-inputtext,
::ng-deep .container .p-dropdown-label,
::ng-deep .container .p-multiselect-label,
::ng-deep .container .p-dropdown-item,
::ng-deep .container .p-multiselect-option {
  font-size: 1rem;
  line-height: 1.4;
}
::ng-deep .container .p-message .p-message-text {
  font-size: 0.9375rem;
  line-height: 1.4;
}
/*# sourceMappingURL=new-price.component-X3I53RI6.css.map */
